import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
// flarum/tags' hero and fof/follow-tags' modals, patched when they register.
const TAG_HERO = 'ext:flarum/tags/forum/components/TagHero';
const CHOOSE_TAGS_MODAL = 'ext:fof/follow-tags/forum/components/ChooseTagsToFollowModal';
const SUBSCRIPTION_MODAL = 'ext:fof/follow-tags/forum/components/SubscriptionModal';
/**
 * fof/follow-tags, in the theme's layout (styled in follow-tags.less):
 * - a tag's Follow button moves from under "Start a Discussion" into the
 *   tag's hero, beside its name, where it reads as following *this* tag;
 * - "Choose tags to follow" on /following gets a star;
 * - the choose-tags modal opens with a line on what following does.
 *
 * fof/follow-tags is an optional dependency, so its own extensions have run
 * by the time these see the items.
 */
export default function followTags() {
  extend(IndexSidebar.prototype, 'items', function (items) {
    if (items.has('subscriptionButton')) items.remove('subscriptionButton');
  });
  extend(TAG_HERO, 'bodyItems', function (items) {
    const tag = this.attrs.model;
    const SubscriptionStateButton = flarum.reg.get('fof-follow-tags', 'forum/components/SubscriptionStateButton');
    if (!app.session.user || !tag || !SubscriptionStateButton) return;
    items.add('bdFollow', m("div", {
      className: "BdTagHero-follow"
    }, m(SubscriptionStateButton, {
      className: "Button",
      subscription: tag.subscription(),
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport(SUBSCRIPTION_MODAL), {
        model: tag
      })
    })), 70);
  });
  extend(IndexPage.prototype, 'viewItems', function (items) {
    if (!items.has('chooseTagsToFollow')) return;
    const button = items.get('chooseTagsToFollow');
    button.attrs.icon = 'fas fa-star';
    button.attrs.className = 'Button BdChooseTagsButton';
  });
  extend(CHOOSE_TAGS_MODAL, 'content', function (content) {
    if (!Array.isArray(content)) return;
    content.unshift(m("p", {
      className: "BdChooseTags-intro"
    }, app.translator.trans('bimmerdock-theme.forum.follow_tags.choose_intro')));
  });
}